<template lang="pug">
.builds
  vue-good-table(
    ref="table"
    :columns="columns"
    :rows="builds"
    :sort-options=`{
      enabled: true,
      initialSortBy: {
        field: 'assembly_at',
        type: 'asc'
      }
    }`
    :pagination-options=`{
      enabled: true,
      perPage: 20,
      nextLabel: $t('pagination.next'),
      prevLabel: $t('pagination.back'),
      rowsPerPageLabel: $t('pagination.output'),
      allLabel: $t('pagination.all'),
      ofLabel: $t('pagination.of'),
    }`
    @on-row-click="onClickBuildsRow"
    @on-column-filter="onColumnFilter"
  )
    div(slot="emptystate") Установите планируемую "Дату монтажа" на страницах ваших заказов и здесь будет отображаться наглядный график монтажей ваших заказов
    template(slot="table-row" slot-scope="props")
      span(v-if="props.column.field == 'size'")
        | {{ formatSize(props) | dimensions }}
      span(v-else-if="props.column.field == 'options'").btn-icon__wrapper.vgt-table__options-cell
        router-link.btn.btn-icon(
          title="Посмотреть карточку клиента"
          :to=`{
            name: 'clients.client',
            params: { clientId: getClientId(props.index) }
          }`
        )
          font-awesome-icon.sidebar__menu-icon(icon="user")
        router-link.btn.btn-icon(
          title="Посмотреть заказ"
          :to=`{
            name: 'orders.order',
            params: { orderId: getOrderId(props.index) },
          }`
        )
          font-awesome-icon.sidebar__menu-icon(icon="eye")
        //- router-link.btn.btn-icon(
        //-   title="Изменить модель"
        //-   :to=`{
        //-     name: 'orders.order.edit',
        //-     params: { orderId: getOrderId(props.index) },
        //-   }`
        //- )
        //-   font-awesome-icon.sidebar__menu-icon(icon="cog")
        router-link.btn.btn-icon(
          title="Написать клиенту"
          :to=`{ name: 'orders.order', hash:'#clientdata', params: {
            orderId: getOrderId(props.index),
            action: 'client' 
          }}`
        )
          font-awesome-icon.sidebar__menu-icon(icon="pen")
      span(v-else) {{ props.formattedRow[props.column.field] }}
</template>

<script>
import { VueGoodTable } from 'vue-good-table';

// Icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faEye, faCog, faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import config from '@/config';
import table from '@/mixins/table.mixin';

library.add(faUser, faEye, faCog, faPen);

export default {
  mixins: [table],

  props: {
    constructorNames: {
      type: Array,
      required: true,
      default: () => []
    },
    orderStatuses: {
      type: Array,
      required: true,
      default: () => []
    },
    builds: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      columns: [
        {
          label: '№ заказа',
          field: 'number',
          type: 'number',
          thClass: 'vgt-table__cell--min-width',
          filterOptions: {
            enabled: true,
            placeholder: '№ заказа'
          }
        },
        {
          label: 'Номер договора',
          field: 'contract_number',
          filterOptions: {
            enabled: true,
            placeholder: 'Номер договора'
          }
        },
        {
          label: 'Тип шкафа',
          field: 'constructor_type',
          filterOptions: {
            enabled: true,
            placeholder: 'Тип шкафа',
            filterDropdownItems: this.constructorNames
          }
        },
        {
          label: 'Размеры шкафа',
          field: 'size',
          filterOptions: {
            enabled: false
          },
          sortable: true,
          sortFn: this.sortBySize
        },
        {
          label: 'Клиент',
          field: 'client_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Имя клиента'
          }
        },
        {
          label: 'Дата монтажа',
          field: 'assembly_at',
          type: 'date',
          thClass: 'vgt-table__cell--min-width',
          filterable: true,
          dateInputFormat: config.dateTimeInputFormat,
          dateOutputFormat: config.dateOutputFormat,
          filterOptions: {
            enabled: true,
            placeholder: 'Дата монтажа',
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: 'Опции',
          field: 'options',
          thClass: 'vgt-table__cell--min-width',
          sortable: false
        }
      ]
    };
  },

  methods: {
    getClientId(rowIndex) {
      return this.builds[rowIndex].client_id;
    },

    getOrderId(rowIndex) {
      return this.builds[rowIndex].id;
    },

    getOrderRouteProps(rowIndex) {
      return {
        clientId: this.builds[rowIndex].client_id,
        orderId: this.builds[rowIndex].number
      };
    },

    formatSize(data) {
      return {
        width: data.row.width,
        height: data.row.height,
        depth: data.row.depth
      };
    },

    onClickBuildsRow(params) {
      this.$router.push({
        name: 'orders.order',
        params: { orderId: params.row.id }
      });
    }
  },

  components: {
    FontAwesomeIcon,
    VueGoodTable
  }
};
</script>
